import React from 'react';
import * as queries from './graphql/queries';
import * as subscriptions from './graphql/subscriptions';
import { Link } from "react-router-dom";
import { Connect } from 'aws-amplify-react';
import { API, graphqlOperation } from 'aws-amplify';
import moment from 'moment';
import formatTRT from './lib/formatTRT';

const getDownload = async (sid) => {
    const composition = await API.graphql(graphqlOperation(queries.getComposition, {sid}));
    console.log(composition.data.getComposition.mediaLocation)
    window.location.href = composition.data.getComposition.mediaLocation;
}

const MyRooms = ({user}) => {
    return (<Connect
        query={graphqlOperation(queries.listRooms, {user})}
        subscription={graphqlOperation(subscriptions.updatedRoom)}
        onSubscriptionMsg={(prev, { updatedRoom }) => {
            if (updatedRoom.user_id === user) {
                console.log(updatedRoom)
                if (prev.listRooms.some(x => x.id === updatedRoom.id)) {
                    // this exists, we should update
                    let listRooms = prev.listRooms;
                    listRooms.forEach((room,i) => {
                        if (room.id === updatedRoom.id) {
                            listRooms[i] = updatedRoom;
                        }
                    })
                    return Object.assign({}, prev, {listRooms})
                }
                else {
                    // doesnt exist, lets add to the list
                    return Object.assign({}, prev, {listRooms: [updatedRoom, ...prev.listRooms]})
                }
            }
            return prev;
        }}
        >
        {({loading, error, data}) => {
            if (loading) return <>loading...</>
            if (error) return <>error</>
            return (
                <table>
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Status</th>
                            <th>Started</th>
                            <th>Recordings</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.listRooms.sort((a,b) => {
                            if (a.started > b.started) return -1;
                            if (a.started < b.started) return 1;
                            return 0;
                        }).map(room => <tr key={room.id}>
                            <td>
                                {(!room.status || room.status.toLowerCase() !== 'completed')?
                                    <Link to={room.scheduled?`/scheduled/${room.id}`:`/rooms/${room.id}`}>{room.title}</Link>:
                                    <>{room.title}</>
                                }</td>
                            <td>{room.status}</td>
                            <td>{moment.unix(room.scheduled?room.scheduled:room.started).format("M/DD/YYYY - h:mm:ss a")}</td>
                            <td>
                                {room.type === "recorded" &&
                                    <ul>
                                        {room.processedRecordings && room.processedRecordings.map(recording => <li key={recording.id}>
                                            {Number.isInteger(recording.duration) && <>
                                                Runs {formatTRT(recording.duration)} -
                                                <button onClick={() => getDownload(recording.id)}>Download</button>
                                            </>}
                                            {!Number.isInteger(recording.duration)  && <>
                                                Processing: {recording.pctDone}% Complete
                                            </>}
                                        </li>)}
                                    </ul>
                                }
                                {room.type !== "recorded" && 
                                    <>Live</>
                                }
                            </td>
                        </tr>)}
                    </tbody>
                </table>
            )
        }}
    </Connect>)
};

export default MyRooms;